import { toCurrencyTruncated } from '@/utilities/formatting';
import type {
  AnalysisState,
  Shareholder,
  Formatting,
} from '@/pages/CompanyReport/redux/interface/interface';
import type { useOwnershipTranslations } from './hooks/useOwnershipTranslation';

export const calculateHoldingValue = (
  shareholder: Shareholder,
  analysis: AnalysisState,
  formatting: Formatting
) => {
  return toCurrencyTruncated(
    (shareholder.percentOfSharesOutstanding / 100) *
      analysis.marketCapRawData.listing,
    1,
    formatting.tradingItemCurrencyISO
  );
};

export enum Keys {
  institutions = 'Institutions',
  publicCompanies = 'Public Companies',
  privateCompanies = 'Private Companies',
  individualInsiders = 'Individual Insiders',
  companyControlledFoundation = 'Company Controlled Foundation',
  employeeShareScheme = 'Employee Share Scheme',
  stateOrGovernment = 'State or Government',
  hedgeFunds = 'Hedge Funds',
  VCPEFirms = 'VC/PE Firms',
  sovereignWealthFunds = 'Sovereign Wealth Funds',
  generalPublic = 'General Public',
}

export function stringIsKey(label: string): label is Keys {
  return Object.values(Keys).includes(label as Keys);
}

export function getTranslationKey(
  label: Keys
): Parameters<ReturnType<typeof useOwnershipTranslations>>[0] {
  switch (label) {
    case Keys.institutions:
      return 'ownerType.institutions';
    case Keys.publicCompanies:
      return 'ownerType.publicCompanies';
    case Keys.privateCompanies:
      return 'ownerType.privateCompanies';
    case Keys.individualInsiders:
      return 'ownerType.individualInsiders';
    case Keys.companyControlledFoundation:
      return 'ownerType.companyControlledFoundation';
    case Keys.employeeShareScheme:
      return 'ownerType.employeeShareScheme';
    case Keys.stateOrGovernment:
      return 'ownerType.stateOrGovernment';
    case Keys.hedgeFunds:
      return 'ownerType.hedgeFunds';
    case Keys.VCPEFirms:
      return 'ownerType.VCPEFirms';
    case Keys.sovereignWealthFunds:
      return 'ownerType.sovereignWealthFunds';
    case Keys.generalPublic:
      return 'ownerType.generalPublic';
  }
}
